import { sentry } from '@frontend/tracking';

type SentryDetailError = Error & { sentryDetailError?: string };

export const paymentsSentry = {
  error: (error: string | Error, name: string, additionalErrorMessage: string) => {
    const normalizedError = typeof error === 'string' ? new Error(error) : error;
    const sentryDetailError = (normalizedError as SentryDetailError).sentryDetailError;

    /**
     * Sentry display notes
     * title/h1: error.name
     * subtitle/h2: error.message
     * context: on the context section of the page
     *
     * Default Error.name = 'Error', so it's not really helpful.
     */

    return sentry.error({
      team: 'payments',
      topic: 'payments',

      /**
       * Will use error.message as the h2/subheading underneath the h1/title.
       */
      error: normalizedError,
      severityLevel: 'error',
      addContext: {
        name: 'location',
        context: {
          /**
           * All context values will show up under sentry's "contexts" section of the error details.
           */
          name,
          additionalErrorMessage,
          sentryDetailError,
        },
      },
    });
  },
  log: (message: string, data: Record<string, unknown>) =>
    sentry.log({
      team: 'payments',
      severityLevel: 'info',
      message,
      data,
    }),
};
